import { CreateShortlist } from '@statsbomb/kitbag-shortlists';
import { atom } from 'jotai';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';
import { EntityTopBar } from '@/components/topBar/EntityTopBar';
import { AppShellContents } from '../AppShell';

export const RecruitmentListLayout = () => {
  const { t } = useTranslation('navigation');
  const translatedNameAtom = useMemo(() => atom(() => t('primary.recruitmentList')), [t]);

  return (
    <AppShellContents
      topBar={<EntityTopBar selectedEntityNameAtom={translatedNameAtom} actions={<CreateShortlist />} />}
    >
      <Outlet />
    </AppShellContents>
  );
};
